import { useState, useEffect } from 'react';

const cachedScripts: string[] = [];
export const useScript = (
  src: string | null = null,
  removeAfter?: boolean,
): [boolean, boolean] => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!src) {
      setError(false);
      return undefined;
    }

    if (cachedScripts.includes(src)) {
      setLoaded(true);
      setError(false);
    } else {
      cachedScripts.push(src);

      const script = document.createElement('script');
      script.src = src;
      script.async = true;

      const onScriptLoad = () => {
        setLoaded(true);
        setError(false);
      };

      const cleanupScript = () => {
        const index = cachedScripts.indexOf(src);
        if (index >= 0) cachedScripts.splice(index, 1);
        script.remove();
      };

      const onScriptError = () => {
        cleanupScript();

        setLoaded(true);
        setError(true);
      };

      script.addEventListener('load', onScriptLoad);
      script.addEventListener('error', onScriptError);

      document.body.appendChild(script);

      return () => {
        script.removeEventListener('load', onScriptLoad);
        script.removeEventListener('error', onScriptError);

        if (removeAfter) {
          cleanupScript();
        }
      };
    }

    return undefined;
  }, [src, removeAfter]);

  return [loaded, error];
};
